import React from "react";
import { Grid, Box } from "@mui/material";
import LoadingScreen from "../../components/LoadingScreen";
import { isObjectEmpty } from "../../util/generalHelp";
import PropTypes from 'prop-types'
import HomeDisplay from "../../components/Home/HomeDisplay";
/**
 * Home page for users
 * @component 
 * @category Pages
 * @subcategory Consultant 
 */
function Home(props) {
  return (
    <div className="Panel">
      {!(isObjectEmpty(props.profile)) ? (
        <>
          <Grid container>
          <Grid item container xs={4} sx={{ bgcolor: "black" }}>
            <Box
              sx={{
                boxShadow: 5,
                height: '100%',
                minHeight:'93vh',
                m: "0.25%",
                mt:'0%',
                mb:'0%',
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "background.default",
                color: "primary.contrastText",
              }}
            >
              <HomeDisplay profile={props.profile}/>
            </Box>
          </Grid>
          <Grid item container xs={8}>
            <div
              style={{
                width: "100%",
                backgroundSize: "max(cover, 100%)",
                background: `url(https://i.pinimg.com/originals/21/0c/25/210c25411bb8f28396944a476471cc5f.jpg)`,
              }}
            >
            </div>
          </Grid>
          </Grid>
      </>
      ) : (
        <LoadingScreen />
      )}
    </div>
  );
}

Home.propTypes ={
  profile: PropTypes.object.isRequired
}

export default Home;
